export default "__VITE_ASSET__Bef7y1Sp__"